export const ROUTES = {
  RC_TOUR_KIDS_AND_FAMILY: 'rockefeller-center-kids-tour',
  VIP_ROCKSTAR: 'vip-rock-pass',
  RC_ROCK_PASS_VIP_HOLIDAY: 'vip-rock-pass-holiday-edition',
  CHALETS: 'the-rink-chalets',
  RINK_VIP: 'the-rink-vip',
  TREEPHOTO: 'tree-photo',
  SANTA_PHOTO: 'santa-photo',
  THE_BEAM_PASS: 'the-beam-pass',
  ALL_IN_PASS: 'all-in-pass',
};
